export const MEMBRANE_CUT_OFF = {
  CHIP_5_KDA: 5,
  CHIP_10_KDA: 10,
  CHIP_30_KDA: 30,
  CHIP_50_KDA: 50,
  CHIP_100_KDA: 100,
  CHIP_300_KDA: 300,
};
export const MEMBRANE_CUT_OFF_LABEL = {
  [MEMBRANE_CUT_OFF.CHIP_5_KDA]: '5 kDa',
  [MEMBRANE_CUT_OFF.CHIP_10_KDA]: '10 kDa',
  [MEMBRANE_CUT_OFF.CHIP_30_KDA]: '30 kDa',
  [MEMBRANE_CUT_OFF.CHIP_50_KDA]: '50 kDa',
  [MEMBRANE_CUT_OFF.CHIP_100_KDA]: '100 kDa',
  [MEMBRANE_CUT_OFF.CHIP_300_KDA]: '300 kDa',
};
